module.exports = __webpack_public_path__ + "static/media/Icona-2.2216ba0b.svg";